import { render, staticRenderFns } from "./TitleDescription.vue?vue&type=template&id=6ab38ad2&scoped=true&"
import script from "./TitleDescription.vue?vue&type=script&lang=js&"
export * from "./TitleDescription.vue?vue&type=script&lang=js&"
import style0 from "./TitleDescription.vue?vue&type=style&index=0&id=6ab38ad2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab38ad2",
  null
  
)

export default component.exports